import { IonButton, IonGrid, IonRow, IonCol, IonIcon, IonItemSliding, IonContent, useIonLoading, IonHeader, IonItem, IonLabel, IonPage, IonText, IonNote, IonThumbnail, RefresherEventDetail, useIonAlert, IonRefresher, IonInfiniteScroll, IonInfiniteScrollContent, IonItemOptions, IonItemOption, IonToolbar, IonButtons, useIonModal, IonTitle } from '@ionic/react'
import React, { useEffect, useState } from 'react'
import moment from "moment";
import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';
import "./GeneratePdf.css"
import AppHeader from '../../components/AppHeader/AppHeader';
import { Capacitor } from '@capacitor/core';
import { AccountStamentsParameters, Asset, DocumentTransactionStatus, PageLinks } from '../../types/types';
import { ebioroApi, useDeleteAccountStatementMutation } from '../../services/api/ebioro/ebioro';
import { useAppDispatch, useAppSelector } from '../../services/redux/hook';
import { closeOutline, documentOutline, trash, arrowBackOutline } from 'ionicons/icons';
import { useTranslation } from 'react-i18next';
import AssetModal from '../../components/AssetModal/AssetModal';
import * as Sentry from '@sentry/react'
import { Filesystem, Directory } from '@capacitor/filesystem';
import { FileOpener, FileOpenerOptions } from '@capacitor-community/file-opener';
import GeneratePdfRequest from './GeneratePdfRequest';
import { useInterval } from 'usehooks-ts'
import { closeModal } from '../../services/redux/slices/opened_navigation_modal/opened_root_modal';
import { Provider } from 'react-redux';
import { store } from '../../services/redux/store';



const Page: React.FC = () => {

  const nav = document.querySelector("ion-nav");
  const dispatch = useAppDispatch();

  const close = () => {
    dispatch(closeModal());
  }

  const [presentDeleteAlert] = useIonAlert();

  let dataToPrint: any[] = [];

  const [present] = useIonAlert();
  const presentErrorAlert = (message: string) => {

    present({
      header: 'Error',
      message: `${message}`,
      buttons: [
        {
          text: 'Close',
          role: 'cancel',
          handler: () => {
            return
          }
        }
      ],
    })

  }

  const [goBack, setGoBack] = useState(false);


  const userInfo = useAppSelector((state) => state.user);
  const walletInfo = useAppSelector((state) => state.walletInfo);
  const supportedAssets: Asset[] = useAppSelector((state) => state.supportedAssets.supportedAssets);

  const { t, i18n } = useTranslation();
  const selectedAsset = useAppSelector((state) => state.selectedAsset);

  const [presentAssetModal, dismissAssetModal] = useIonModal(
    <AssetModal
      closeModal={() => dismissAssetModal()}
    />);


  const [currentPage, setCurrentPage] = useState(1);
  const [accountStatementsLimit] = useState(20);
  const [accountStatements, setAccountStatements] = useState<any[]>([]);
  const [isInfiniteDisabled, setInfiniteDisabled] = useState(false);

  const [presentLoading, dismissLoading] = useIonLoading();

  const [deleteAccountStatement, deleteAccountStatementResult] = useDeleteAccountStatementMutation();

  const loadMoreLinksInitialState: PageLinks = {
    first: "",
    previous: "",
    next: "",
    last: ""
  }

  const [currentLinks, setCurrentLinks] = useState<PageLinks | undefined>(loadMoreLinksInitialState)

  let params: AccountStamentsParameters = {
    page: currentPage,
    limit: accountStatementsLimit,
    user_id: userInfo.id
  }

  const isPlatform = Capacitor.getPlatform();


  let StartingBalance = 0;
  let EndingBalance = 0;

  const printpdf = async (item: any) => {

    getTransaction(item.transactions);

    //add date the body of table
    const body = [...dataToPrint,
    [
      {
        content: `${t('Pdf.page.TABLE_STARTING_BALANCE')} = ${StartingBalance.toFixed(2)} ${selectedAsset.display_code}`,
        colSpan: 4,
        size: 6,
        styles: {
          fillColor: "#eeeeee",
          textColor: 'black',
          fontSize: 11,


        }
      },

      {
        content: `${t('Pdf.page.TABLE_ENDING_BALANCE')} = ${EndingBalance.toFixed(2)} ${selectedAsset.display_code}`,
        colSpan: 4,

        styles: {
          fillColor: "#eeeeee",
          textColor: 'black',
          fontSize: 11,
          halign: 'right'

        }
      },



    ]
    ];

    //customize the table
    const tableOptions: any = {
      startY: 104,
      head: [[t('Pdf.page.TABLE_HEADER_DATE'), t('Pdf.page.TABLE_HEADER_DESCRIPTION'),
      t('Pdf.page.TABLE_HEADER_MONEY_IN'), t("Pdf.page.TABLE_HEADER_MONEY_OUT"),
      t('Pdf.page.TABLE_COUNTER_PARTY'), t('Pdf.page.TABLE_HEADER_BALANCE'),
      ]
      ],
      tableHeight: -8,
      columnStyles: [
        {
          cellWidth: "wrap",

        },
        {
          cellWidth: "wrap",
          halign: 'center',

        },
        {
          cellWidth: "wrap",
          halign: 'center',
          textColor: "#3880ff"

        },
        {
          cellWidth: "wrap",
          halign: 'center',
          textColor: "#FD5D44"

        },
        {
          cellWidth: "wrap",
          halign: 'center',


        },
        {
          cellWidth: "wrap",
          halign: 'center',

        },

      ],
      body,
      rowPageBreak: 'avoid',
      showHead: 'everyPage',
      styles: {
        font: 'times',
        fontSize: 10,
      },
      headStyles: {
        fillColor: '#eeeeee',
        textColor: 'black',
        fontSize: 11,
        halign: 'center'

      },
      margin: { bottom: 50, top: 60 },
      alternateRowStyles: {
        fillColor: [255, 255, 255],
      },

      didDrawPage: function (data: any) {

        let img = new Image()
        img.src = 'assets/img/ebioro-horizontal-blue-orange.png'
        doc.addImage(img, 'JPEG', data.settings.margin.left, 15, 70, 30)

        let today = new Date().getFullYear();
        let newdate = "@" + today;
        doc.setFontSize(10);
        let pageSize = doc.internal.pageSize;
        let pageHeight = pageSize.height
          ? pageSize.height
          : pageSize.getHeight();
        doc.text(t('Pdf.page.INFORMATION_EBIORO') as string, data.settings.margin.right, pageHeight - 40, { maxWidth: 120 });
        doc.text(newdate, 15, 287);

      },
    };


    const doc = new jsPDF({
      orientation: 'p',
      unit: 'mm',
      format: 'a4',

    });


    //all the text of pdf page

    doc.text(t('Pdf.Page.ACCOUNT_LABEL') as string, 15, 70)
    doc.setFontSize(20)
    doc.text(`${userInfo?.first_name} ${userInfo?.last_name}`, doc.internal.pageSize.width / 1.3, 30, {
      align: 'center',
    })
    doc.setFontSize(15)
    doc.text(`${t('Pdf.page.DATE.RANGE_NOTE')} ${item.file_name.split('_')[0]} ${t('Pdf.page.DATE.RANGE_NOTE_2')} ${item.file_name.split('_')[1]}`, 15, 95)
    doc.setFontSize(11)

    doc.text(walletInfo.account_key as string, 15, 75)
    doc.setFontSize(11)


    doc.text(`${t('Pdf.Page.PAGE_GENERATED_ON')} ${moment(item.updatedAt).format('D MMM YYYY')}`, 15, 100)
    doc.setFontSize(8)


    // let addressOfUser = doc.splitTextToSize(`${userInfo.address.address_1} ${userInfo.address.city}`, 70)
    // doc.text(addressOfUser, doc.internal.pageSize.width / 1.3, 37, {
    //   align: "center"
    // })



    //footer of pdf page
    const addFooters = (doc: any) => {
      const pageCount = doc.internal.getNumberOfPages()
      doc.setFontSize(8)
      for (var i = 1; i <= pageCount; i++) {
        doc.setPage(i)
        doc.text(`${t('Pdf.Page.PAGE_NO')} ${String(i)} ${t('Pdf.Page.PAGE_NO_2')} ${String(pageCount)}`, doc.internal.pageSize.width / 1.2, 287, {
          align: 'center'
        })

      }
    }

    //it will create a table 
    autoTable(doc, tableOptions);

    addFooters(doc);

    // function for view the Pdf  
    //let pdfOutput = doc.output("blob");
    let pdfOutput = doc.output("datauristring");

    if (isPlatform === "android" || isPlatform == 'ios') {
      // for Android device
      //const directory = File.externalRootDirectory + 'Download/';
      const fileName = `ebioroapp-statement-${new Date().getTime()}.pdf`;

      await Filesystem.writeFile({
        path: fileName,
        data: pdfOutput,
        directory: Directory.Data,
        //encoding: pdfOutput.get,
      });

      let uriResult = await Filesystem.getUri({
        directory: Directory.Data,
        path: fileName
      })

      const path = uriResult.uri;
      const options: FileOpenerOptions = {
        filePath: path,
        contentType: 'application/pdf'
      }

      await FileOpener.open(options)

    }

    else {
      doc.save("Ebioro.pdf");

    }

  }


  const getTransaction = async (alltarnsaction: any[]) => {

    dataToPrint = [];

    if (alltarnsaction.length) {

      alltarnsaction.map((transactions: any) => {
        dataToPrint.push([
          moment.unix(transactions.operation[0].timestamp).format('DD MM YYYY'),
          (transactions.operation[0].type === 'path_payment_strict_send') ?
            (`${t('operations.pathpayment.STRICT-SEND.TRADE-LABEL-PART')} ${transactions.operation[0].sourceToken?.code} to ${transactions.operation[0].token.code}`)
            : (transactions.effect.type === 'account_created' || transactions.effect.type === 'trustline_created') ? t('operations.create_account.LABEL') :
              transactions.operation[0].description,
          transactions.effect.type === "account_credited" ? `+ ${parseFloat(transactions.effect.amount).toFixed(2)}` : "0.00",
          transactions.effect.type === "account_debited" ? `- ${parseFloat(transactions.effect.amount).toFixed(2)}` : "0.00",
          transactions.operation[0].name,
          parseFloat(transactions.effect.balance).toFixed(2)
          // (transactions.operation[0].type === 'path_payment_strict_send' && transactions.effect.type === "account_debited") 
          // ?transactions.operation[0].sourceToken.code:
          // transactions.operation[0].token.code

        ]);



      });

      EndingBalance = alltarnsaction[0].effect.balance;
      StartingBalance = alltarnsaction[alltarnsaction.length - 1].effect.balance;

    }

    return dataToPrint

  }

  const openAssetModal = () => {

    presentAssetModal({
      initialBreakpoint: 0.40,
      breakpoints: [0, 0.40, 0.5, 0.75],
      onDidDismiss: (() => { nav?.push(() => <GeneratePdfRequest />) })
    })

  }

  const loadFirstStatements = async () => {

    try {

      const response = await dispatch(ebioroApi.endpoints.getAccountStaments.initiate(params, { forceRefetch: true })).unwrap();
      setAccountStatements(response.items);
      setCurrentLinks(response.links);



    } catch (error) {
      Sentry.captureException(error)
      presentErrorAlert(t('application.uncaught.ERROR'))
    }

  }

  async function doRefresh(event: CustomEvent<RefresherEventDetail>) {

    try {

      await presentLoading();
      setInfiniteDisabled(false);
      const response = await dispatch(ebioroApi.endpoints.getAccountStaments.initiate(params, { forceRefetch: true })).unwrap();
      setAccountStatements(response.items);
      setCurrentLinks(response.links);
      await dismissLoading();
      event.detail.complete();

    } catch (error) {

      Sentry.captureException(error)
      presentErrorAlert(t('application.uncaught.ERROR'))

    }


  }

  const loadMoreEvent = async ($event: CustomEvent<void>) => {

    if (currentLinks?.next && currentLinks?.next.length !== 0) {

      let url = new URL(currentLinks.next);
      let search_params = url.searchParams;

      const page = search_params.get('page');
      const limit = search_params.get('limit');


      if (page) {

        params.page = parseInt(page);

        if (limit) {
          params.limit = parseInt(limit)
        }

        try {

          const response = await dispatch(ebioroApi.endpoints.getAccountStaments.initiate(params, { forceRefetch: true })).unwrap();

          setAccountStatements((accountStatements) => [...accountStatements, ...response.items]);
          setCurrentLinks(response.links);

        } catch (error) {

          Sentry.captureException(error)
          presentErrorAlert(t('application.uncaught.ERROR'))

        }
      }

    }

    ($event.target as HTMLIonInfiniteScrollElement).complete();
  }

  const deleteStatement = async (id: string) => {

    try {

      await document.querySelector("ion-item-sliding")?.closeOpened();

      await deleteAccountStatement({ id }).unwrap();

      setTimeout(async () => {

        await loadFirstStatements();
      }, 500) // somehow need to add this here because calling display beneficiary direcltly without the timeout does not work

    } catch (error) {

      presentErrorAlert(JSON.stringify(error))

    }

  }

  const confirmDeleteStatement = (id: string) => {

    presentDeleteAlert({
      header: t('GeneratePdf.page.STATEMENT-DELETE-CONFIRM-ALERT-MESSAGE'),
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          handler: () => {
            { };
          },
        },
        {
          text: 'OK',
          role: 'confirm',
          handler: async () => {
            await deleteStatement(id);
          },
        },
      ],
    })

  }

   const handleNavigation = () => {
        if (goBack) {
            nav?.pop();
        } else {
            close();
        }
    }

  // Interval to keep track of new statements.
  useInterval(async () => {

    await loadFirstStatements();

  }, 3000);

  // load first statements.
  useEffect(() => {

    const init = async () => {
      await loadFirstStatements();
    }

    init();
  }, [])

  useEffect(() => {

    const init = async () => {
      const canGoBackResult = await nav?.canGoBack();
      if (canGoBackResult) {
        setGoBack(true);
      }
    }
    init();
  }, []);

  return (
    <IonPage>
      <IonHeader className="ion-no-border">
        <IonToolbar style={{ marginTop: "0%" }}>
          <IonButtons slot='start'>
            <IonButton onClick={handleNavigation} color='primary'>
              <IonIcon
                slot="icon-only"
                icon={goBack ? arrowBackOutline : closeOutline}
              />
            </IonButton>
          </IonButtons>
          <IonTitle> {t('GeneratePdf.page.PAGE_HEADER') as string}</IonTitle>

        </IonToolbar>

      </IonHeader>

      <IonContent>
        <IonGrid className='ion-padding' >
          <IonRow style={{ marginTop: '10%' }}>
            <IonCol className='ion-text-start' >
              <IonButton

                fill='outline'
                onClick={() => { openAssetModal() }}
                color='primary'
                size='small'>
                <IonIcon slot="start" icon={documentOutline} />
                <IonLabel>
                  {t('GeneratePdf.Page.BUTTON_LABEL')}
                </IonLabel>
              </IonButton>

            </IonCol>
          </IonRow>

        </IonGrid>

        <div className='ion-text-center generatePdf_statement_empty' hidden={(accountStatements.length != 0)}>
          <IonText> {t('GeneratePdf.page.NO_STATEMENT_MESSAGE')}</IonText>
        </div>

        <IonRefresher slot="fixed" onIonRefresh={doRefresh} />

          {accountStatements.map((item: any, index: any) => {

            const asset = supportedAssets.filter((element) => {

              return (item.asset_code === element.code)
            })

            if (asset) {

              return (

                <IonItemSliding key={index}>
                  <IonItem className='generatePdfitemList' detail={true} lines='none' disabled={item.status === DocumentTransactionStatus.pending || item.status === DocumentTransactionStatus.error}>

                    <IonItem lines='none' className='generatePdfitemList' onClick={() => { { printpdf(item) } }}>

                      <IonThumbnail className="accountsPage_Thumbnail_Flag" slot="start">
                        <img src={asset[0].icon}
                        />
                      </IonThumbnail>

                      <IonLabel className="accountsPage_AssetLabel">
                        <h4>
                          {item.file_name}_{item.asset_code}
                        </h4>

                        <IonNote className="operationsItem_IonNote ion-text-wrap" hidden={item.status === DocumentTransactionStatus.completed}

                          color={(item.status === DocumentTransactionStatus.pending) ? 'warning' : item.status === DocumentTransactionStatus.error ? 'danger'
                            : 'primary'
                          }

                        >

                          {item.status}

                        </IonNote>
                      </IonLabel>

                    </IonItem>

                  </IonItem>
                  <IonItemOptions>
                    <IonItemOption color="danger"

                      onClick={() => { confirmDeleteStatement(item.id) }}>
                      <IonIcon slot="icon-only" icon={trash} color="light"></IonIcon>
                    </IonItemOption>
                  </IonItemOptions>
                </IonItemSliding>

              )


            }

          })}

   

        <IonInfiniteScroll
          onIonInfinite={loadMoreEvent}
          threshold="15px"
          disabled={isInfiniteDisabled}

        >
          <IonInfiniteScrollContent
            loadingSpinner="bubbles"
            loadingText={t('buy-sell.list.INFINITE-SCROLL-CONTENT-LOADING-TEXT') as string}
          ></IonInfiniteScrollContent>
        </IonInfiniteScroll>

      </IonContent>

    </IonPage>

  )
}

const GeneratePdf: React.FC = () => (
  <Provider store={store}>
    <Page />
  </Provider>
);

export default GeneratePdf;


